import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Colors } from "../../../styles/adminTheme";
import { getAncestors, getCategoryNameById } from "./helpers/productForm.utils";

export default function ProductsTable({ products, categories, onEdit, onDelete, resolveImgSrc }) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>שם</TableCell>
            <TableCell>מחיר</TableCell>
            <TableCell>כמות</TableCell>
            <TableCell>תיאור</TableCell>
            <TableCell>פעולות</TableCell>
            <TableCell>תמונה</TableCell>
            <TableCell>קטגוריה</TableCell>
            <TableCell>תת קטגוריה</TableCell>
            <TableCell>תת תת קטגוריה</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {products.map((p) => {
            const { parentId, childId, subId } = getAncestors(categories, p.categoryId);

            return (
              <TableRow key={p.id}>
                <TableCell>{p.name}</TableCell>
                <TableCell>{p.price}</TableCell>
                <TableCell>{p.quantity}</TableCell>
                <TableCell>{p.description}</TableCell>

                <TableCell>
                  <IconButton onClick={() => onEdit(p)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => onDelete(p.id)}>
                    <DeleteForeverIcon sx={{ color: Colors.danger }} />
                  </IconButton>
                </TableCell>

                <TableCell>
                  {p.image && (
                    <img
                      src={resolveImgSrc(p.image)}
                      alt={p.name}
                      style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 6 }}
                      onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                  )}
                </TableCell>

                <TableCell>{getCategoryNameById(categories, parentId) || "-"}</TableCell>
                <TableCell>{getCategoryNameById(categories, childId) || "-"}</TableCell>
                <TableCell>{subId ? getCategoryNameById(categories, subId) : "-"}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
